
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006cac","d":"M16.64 18.234c0-.07-.038-.141-.064-.211a5.072 5.072 0 00-.963-1.514 4.966 4.966 0 10.668 5.788c.141-.277.259-.575.349-.884.048-.146.086-.255.112-.37s.051-.224.07-.339a4.501 4.501 0 00-.005-1.827 4.775 4.775 0 00-.178-.677zm-1.28 2.406H8.499v-1.664h6.822zM16 1.28C7.87 1.28 1.28 7.87 1.28 16S7.87 30.72 16 30.72 30.72 24.13 30.72 16 24.13 1.28 16 1.28zm9.126 19.584a1.448 1.448 0 01-1.446 1.402h-6.702c-.918 1.909-2.836 3.203-5.057 3.203a5.594 5.594 0 112.975-10.332c-.209-.43-.382-.884-.561-1.37a5.134 5.134 0 01-.223-2.068 8.872 8.872 0 01-.036-.829c0-.436.026-.865.078-1.287.456-1.722 1.621-2.208 3.009-2.208s2.56.486 3.002 2.259c.052.363.082.781.082 1.207 0 .31-.016.616-.046.917a3.8 3.8 0 01.022.455c0 .552-.07 1.088-.201 1.599a10.21 10.21 0 01-1.387 2.719c2.133.354 3.547 1.531 4.501 2.018 1.958.928 1.984 1.971 1.984 1.971z"}})])
          )
        }
      }
    